import { createContext } from "react";
export const activosXreportsContext = createContext();